import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 359,
	viewBox: "0 0 411 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_718_1257)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M209.19 358.3C298.936 358.3 371.69 285.546 371.69 195.8C371.69 106.054 298.936 33.3 209.19 33.3C119.444 33.3 46.6899 106.054 46.6899 195.8C46.6899 285.546 119.444 358.3 209.19 358.3Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.42 303.5H249.99C249.16 303.5 248.49 302.83 248.49 302C248.49 301.17 249.16 300.5 249.99 300.5H314.42C315.25 300.5 315.92 301.17 315.92 302C315.92 302.83 315.25 303.5 314.42 303.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.96 303.5H60.73C59.9 303.5 59.23 302.83 59.23 302C59.23 301.17 59.9 300.5 60.73 300.5H241.97C242.8 300.5 243.47 301.17 243.47 302C243.47 302.83 242.8 303.5 241.97 303.5H241.96Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.3601C87.7401 290.69 82.3501 285.3 82.3501 278.68V62.46C82.3501 55.84 87.7401 50.45 94.3601 50.45H260.34",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.36C87.74 290.69 82.35 285.3 82.35 278.68V62.46C82.35 55.84 87.74 50.45 94.36 50.45H260.34M260.33 37.63H94.35C80.64 37.63 69.52 48.75 69.52 62.46V278.68C69.52 292.39 80.64 303.51 94.35 303.51H260.33C274.04 303.51 285.16 292.39 285.16 278.68V62.46C285.16 48.75 274.04 37.63 260.33 37.63Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 0.310001C187.69 0.310001 196.31 8.93 196.31 19.55V30.24H157.83V19.55C157.83 8.93 166.45 0.310001 177.07 0.310001Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 24.5C180.958 24.5 184.11 21.3481 184.11 17.46C184.11 13.5719 180.958 10.42 177.07 10.42C173.182 10.42 170.03 13.5719 170.03 17.46C170.03 21.3481 173.182 24.5 177.07 24.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_718_1257",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 119,
				y: 25,
				width: 116,
				height: 40,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_718_1257)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M241.63 55.98H112.51V68.12H241.63V55.98Z",
					fill: "#FFB100"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.95 139.12C335.97 139.62 335.78 140.12 335.43 140.47L322.82 153.09C322.5 153.41 322.09 153.63 321.65 153.67C321.11 153.71 320.6 153.53 320.23 153.15L314.8 147.72C314.44 147.36 314.25 146.87 314.28 146.37C314.3 145.87 314.54 145.39 314.93 145.07C315.63 144.49 316.71 144.56 317.38 145.23L321.47 149.32C321.47 149.32 321.52 149.34 321.53 149.32L332.87 137.98C333.54 137.31 334.61 137.24 335.32 137.82C335.71 138.14 335.94 138.62 335.97 139.12H335.95Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 125.66C139.845 125.66 147.68 117.825 147.68 108.16C147.68 98.495 139.845 90.66 130.18 90.66C120.515 90.66 112.68 98.495 112.68 108.16C112.68 117.825 120.515 125.66 130.18 125.66Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 100.46H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 116.94H228.01",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 191.1C139.845 191.1 147.68 183.265 147.68 173.6C147.68 163.935 139.845 156.1 130.18 156.1C120.515 156.1 112.68 163.935 112.68 173.6C112.68 183.265 120.515 191.1 130.18 191.1Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 165.89H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 182.38H210.64",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 256.54C139.845 256.54 147.68 248.705 147.68 239.04C147.68 229.375 139.845 221.54 130.18 221.54C120.515 221.54 112.68 229.375 112.68 239.04C112.68 248.705 120.515 256.54 130.18 256.54Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 231.33H192.76",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 247.82H228.01",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 109.32L128.38 113.68L137.55 104.51",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 174.3L128.38 178.65L137.55 169.48",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 240.23L128.38 244.58L137.55 235.41",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6899 169.29C21.7099 169.79 21.5199 170.29 21.1699 170.64L8.55993 183.26C8.23993 183.58 7.82993 183.8 7.38993 183.84C6.84993 183.88 6.33993 183.7 5.96993 183.32L0.53993 177.89C0.17993 177.53 -0.0100701 177.04 0.0199299 176.54C0.0399299 176.04 0.27993 175.56 0.66993 175.24C1.36993 174.66 2.44993 174.73 3.11993 175.4L7.20993 179.49C7.20993 179.49 7.25993 179.51 7.26993 179.49L18.6099 168.15C19.2799 167.48 20.3499 167.41 21.0599 167.99C21.4499 168.31 21.6799 168.79 21.7099 169.29H21.6899Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.97 1.7C278.99 2.2 278.8 2.7 278.45 3.05L265.84 15.67C265.52 15.99 265.11 16.21 264.67 16.25C264.13 16.29 263.62 16.11 263.25 15.73L257.82 10.3C257.46 9.94 257.27 9.45 257.3 8.95C257.32 8.45 257.56 7.97 257.95 7.65C258.65 7.07 259.73 7.14 260.4 7.81L264.49 11.9C264.49 11.9 264.54 11.92 264.55 11.9L275.89 0.559999C276.56 -0.110001 277.63 -0.180001 278.34 0.399999C278.73 0.719999 278.96 1.2 278.99 1.7H278.97Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M410.35 95.27C410.39 96.04 410.09 96.8 409.55 97.35L390.17 116.73C389.68 117.22 389.05 117.56 388.37 117.62C387.55 117.69 386.76 117.4 386.19 116.82L377.84 108.47C377.29 107.92 377 107.16 377.04 106.39C377.08 105.62 377.44 104.89 378.04 104.4C379.12 103.51 380.77 103.61 381.8 104.64L388.09 110.93C388.09 110.93 388.16 110.96 388.19 110.93L405.61 93.51C406.64 92.48 408.28 92.38 409.37 93.27C409.97 93.77 410.33 94.49 410.37 95.27H410.35Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M308.54 209.77V223.1H229.66V266.8C229.66 287.07 246.09 303.51 266.37 303.51H343.51V244.74C343.51 225.43 327.86 209.77 308.54 209.77Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M308.54 169.03H229.66V223.1H308.54V169.03Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M258.52 169.03H229.66V159.21C229.66 155.26 232.86 152.07 236.8 152.07C238.56 152.07 240.25 152.72 241.56 153.89L258.52 169.04V169.03Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M279.68 169.03H308.54V159.21C308.54 155.26 305.34 152.07 301.4 152.07C299.64 152.07 297.95 152.72 296.64 153.89L279.68 169.04V169.03Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M348.12 303.5H334.06C328.25 303.5 323.54 298.79 323.54 292.98C323.54 287.17 328.25 282.46 334.06 282.46H348.12C361.45 282.46 372.3 271.61 372.3 258.28V232.67C372.3 226.86 377.01 222.15 382.82 222.15C388.63 222.15 393.34 226.86 393.34 232.67V258.28C393.34 283.21 373.06 303.5 348.13 303.5H348.12Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask1_718_1257",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 229,
				y: 209,
				width: 115,
				height: 95,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M308.54 209.77V223.1H229.66V266.8C229.66 287.07 246.09 303.51 266.37 303.51H343.51V244.74C343.51 225.43 327.86 209.77 308.54 209.77Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask1_718_1257)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M226.58 239.52H238.13C254.54 239.52 267.86 252.84 267.86 269.25V304.22H226.58V239.52Z",
					fill: "#3F8BFD"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M311.58 207.95H346.56V255.33H335.05C322.1 255.33 311.58 244.81 311.58 231.86V207.95Z",
					fill: "#3F8BFD"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M244.67 197.16C244.67 196.07 243.78 195.18 242.69 195.18C241.6 195.18 240.71 196.07 240.71 197.16C240.71 199.88 241.81 202.35 243.6 204.13C245.38 205.91 247.85 207.02 250.57 207.02C253.29 207.02 255.76 205.92 257.54 204.13C259.32 202.35 260.43 199.88 260.43 197.16C260.43 196.07 259.54 195.18 258.45 195.18C257.36 195.18 256.47 196.07 256.47 197.16C256.47 198.79 255.81 200.27 254.74 201.34C253.67 202.41 252.19 203.07 250.56 203.07C248.93 203.07 247.45 202.41 246.38 201.34C245.31 200.27 244.65 198.79 244.65 197.16H244.67Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M297.49 197.16C297.49 196.07 296.6 195.18 295.51 195.18C294.42 195.18 293.53 196.07 293.53 197.16C293.53 198.79 292.87 200.27 291.8 201.34C290.73 202.41 289.25 203.07 287.62 203.07C285.99 203.07 284.51 202.41 283.44 201.34C282.37 200.27 281.71 198.79 281.71 197.16C281.71 196.07 280.82 195.18 279.73 195.18C278.64 195.18 277.75 196.07 277.75 197.16C277.75 199.88 278.85 202.35 280.64 204.13C282.42 205.91 284.89 207.02 287.61 207.02C290.33 207.02 292.8 205.92 294.58 204.13C296.36 202.35 297.47 199.88 297.47 197.16H297.49Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M270.51 202.79H266.84C265.056 202.79 263.61 204.236 263.61 206.02V206.03C263.61 207.814 265.056 209.26 266.84 209.26H270.51C272.294 209.26 273.74 207.814 273.74 206.03V206.02C273.74 204.236 272.294 202.79 270.51 202.79Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M268.67 216.16V207.89",
				stroke: "#002F75",
				strokeWidth: 4.21,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M262.13 220.48L268.67 216.16",
				stroke: "#002F75",
				strokeWidth: 4.21,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M275.21 220.48L268.67 216.16",
				stroke: "#002F75",
				strokeWidth: 4.21,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_718_1257",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 410.36,
			height: 358.3,
			fill: "white"
		})
	}) })]
});
export default SvgCat;
